import { __ } from '@wordpress/i18n';
import { useRef, useEffect } from "@wordpress/element";

export function ImageSliderHeader(props: { list: { url: string, title?: string, }[], current: number, onBack: Function }) {
  let current = null;
  if (props.current == -1) {
    current = props.list[props.list.length - 1];
  } else if (props.current == props.list.length) {
    current = props.list[0];
  } else {
    current = props.list[props.current];
  }

  return (
    <>
      <button
        onClick={() => props.onBack()}
        className="bg-gray-200 text-gray-800 swt-text-primary hover:opacity-75 px-3 py-2 font-medium text-sm rounded-lg"
      >
        {__("Alle Bilder", "swt-blocks")}
      </button>
      <div className="flex justify-center align-center">
        <div className="font-bold text-2xl leading-normal">{current.title}</div>
      </div>
    </>
  )
}

function ImageSlide(props: { img: { url: string } }) {
  return (
    <div className="flex items-center align-center relative">
      <img data-src={props.img.url} className="swiper-lazy object-contain mx-auto" />
    </div>
  );
}

export function ImageSlider(props: {
  list: { url: string, title?: string, }[],
  open: number,
  onChange: Function
}) {
  const slider = useRef<any>();

  const slides = [];
  props.list.forEach(img => {
    slides.push(<ImageSlide img={img} />);
  });

  useEffect(() => {
    if (slider.current) {
      slider.current.onInit((instance: any) => {
        instance.render(slides, {
          buttonClassName: "text-primary-500",
          autoheight: true,
          navigation: {
            enabled: true
          },
          onInit: (swiper: any) => {
            if (props.open > 0) {
              swiper.slideTo(props.open + 1, 0);
            }
          },
          onSlideChange: (swiper: any) => {
            props.onChange(swiper.activeIndex - 1);
          }
        });
      });
    }
  }, [slider]);

  return (
    <>
      <swt-slider ref={slider} react></swt-slider>
    </>
  );
}
